<h1 class="m-3">Agregar Artículo</h1>
<div class="p-3">
	<form name="addNewItemEasy" (ngSubmit)="save($event)" ngNativeValidate>
		<div class="row">
			<div class="col-3 col-lg-2">
				<app-image-uploader [(image)]="item_info.item.image_id"></app-image-uploader>
			</div>
			<div class="col-9 col-lg-10">
				<label for="name">Nombre</label>
				<input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="item_info.item.name" name="name" required>
			</div>

			<div class="col-12 col-lg-6">
				<app-search-category (categoryId)="item_info.item.category_id = $event" [overflow_content]="false"></app-search-category>
			</div>

			<div class="col-12 col-lg-6">
				<label for="name">Código</label>
				<input type="text" class="form-control" placeholder="Código" [(ngModel)]="item_info.item.code" name="code" required>
			</div>
		</div>
		<div class="table-responsive my-3">
			<table class="table table-bordered">
				<thead>
					<tr class="table-light">
						<th>Lista</th>
						<th>Tipo</th>
						<th>Precio</th>
						<th>IVA</th>
						<th *ngIf="rest.local_preferences.currency_price_preference == 'MULTIPLE_CURRENCY'">Moneda</th>
					</tr>
				</thead>
				<tbody>
					<ng-container  *ngFor="let pl of price_list_list">
						<ng-container  *ngFor="let pt of price_type_list;let i=index">
							<tr>
								<td *ngIf="i==0" [rowSpan]="price_type_list.length" class="align-middle fw-bold">{{pl.name}}</td>
								<td>{{pt.name | titlecase}}</td>
								<td>
									<input type="number" class="form-control form-control-sm" [name]="'pprice_'+pl.id+'-'+pt.id" [(ngModel)]="price_dict[pl.id+'-'+pt.id].price" min="0" step="any" required>
								</td>
								<td>
									<select *ngIf="pt.tax_model=='ALL'" [name]="'tax_'+pl.id+'-'+pt.id" [(ngModel)]="price_dict[ pl.id+'-'+pt.id ].tax_included" class="form-select form-select-sm" required>
										<option value="YES">IVA Incluido</option>
										<option value="NO">Más IVA</option>
									</select>
									<small *ngIf="pt.tax_model != 'ALL'" class="text-muted">{{pt.tax_model=='PLUS_TAX'?'Más IVA':'IVA Incluido'}}</small>
								</td>
								<td *ngIf="rest.local_preferences.currency_price_preference == 'MULTIPLE_CURRENCY'">
									<input type="text" class="form-control form-control-sm" min="0" step="any" list="tipo_precio" minlength="3" maxlength="3" [name]="pl.id+'-'+pt.id" [(ngModel)]="price_dict[ pl.id+'-'+pt.id ].currency_id" placeholder="MXN" required>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>

		<div class="text-end">
			<button type="submit" class="btn btn-primary">Guardar</button>
		</div>
	</form>
</div>
